import {
  designActionWithoutHOfParagraph,
  designActionWithoutMofidyTextOfButtonText
} from '@/components/widgets/list_download/style1/customActions.js'
import {listTitleRules, paragraphRules, textIconButtonRules} from '@/assets/designRules/index.js'
import {isFromUserManagePlat} from "@/components/common/controlBar/controlBarDialog/metaComponent/utils.js";
import {createCssVarityName} from "@/globalPopagation.js";
import {createMuiltLanguagesJson} from "@/components/widgets/nav/repeatNumber.js";

import {supportRtlInNode} from "@/components/widgets/list_product/utils.js";

export const iconActions = [
  {
    name: 'design',
    config: {
      分组1: ['1', '2', '3', '4', '5', '5.1', '5.2', '9.1']
    }
  },
  'hover'
]

export const titleActions = [
  {
    name: 'design',
    groupLayout: 'topBottom',
    config: {
      文字设计: [
        'self_upperLowerCase',
        'self_background',
        'title_textTheme',
        'title_fontFamily',
        'title_fontSize',
        'self_textHollowOut',
        'hollow_color',
        'stroke_color',
        'title_color',
        'title_textStyle',
        'title_textAlign',
        'title_lineHeight',
        'title_letterSpace',
        'self_margin',
        'self_padding',
        'title_h',
        'title_textOverflow'
      ]
    }
  },
  'hover'
]

export const paragraphActions = [designActionWithoutHOfParagraph, 'hover', 'isShow']

export const imageActions = [
  {
    name: 'design',
    groupLayout: 'topBottom',
    config: {
      文字设计: ["self_background",'self_margin', 'self_border', 'self_shadow', 'self_borderRadius']
    }
  },
  'hover'
]

export const image2Actions = [
  {
    name: 'design',
    groupLayout: 'topBottom',
    config: {
      文字设计: [
        'imageAspectRatio',
        'borderBox_background',
        'self_margin',
        'borderBox_border',
        //'borderBox_shadow',
        'borderBox_borderRadius',
      ]
    }
  },
  {
    name: 'hover',
    groupLayout: 'topBottom',
    config: {
      文字设计: ['borderBox_border', 'img_picEffect']
    }
  }
]

export const imageActionsWithoutPicEffect = [
  {
    name: 'design',
    groupLayout: 'topBottom',
    config: {
      文字设计: ["self_background",'self_margin', 'self_border', 'self_shadow', 'self_borderRadius']
    }
  },
  {
    name: 'hover',
    groupLayout: 'topBottom',
    config: {
      文字设计: ['self_border','img_picEffect']
    }
  }
]

export const buttonTextActions = [
  {
    name: 'design',
    groupLayout: 'topBottom',
    config: {
      文字设计: [
        'self_textTheme',
        'self_fontFamily',
        'self_fontSize',
        'self_color',
        'self_textStyle',
        'self_textAlign'
      ],
      按钮设计: [
        'self_background',
        'self_border',
        'self_margin',
        'self_padding',
        // 'self_transverseMargin',
        'self_width',
        'self_borderRadius',
        'self_shadow',
      ]
    }
  },
  'hover',
]

export const buttonTextIconActions = [designActionWithoutMofidyTextOfButtonText, 'hover']

export const buttonIconActions = [
  {
    name: 'design',
    config: {
      分组1: [
        'self_textTheme',
        'self_icon',
        'self_width',
        'self_background',
        'self_color',
        'self_margin',
        'self_border',
        'self_borderRadius',
        'self_shadow'
      ]
    }
  },
  'hover'
]


export const maskActions = [
  {
    name: 'design',
    config: {
      分组1: [
        '3',
        '6'
      ]
    }
  },
  'isShow',
]





export async function requestDwonloadList(attribute) {
  var res = await mm.http({
    url: '/api/download/list',
    params: {
      page: mm.router.currentRoute.value.query.page || 1,
      page_size: attribute.value['pageSize_value'] || 10,
      a_langset_id: mm.store.state.currentLanguage,
      // list_order: attribute.value.sort_value,
      category_id: (() => {
        if (attribute.value.self_selectedType === 'all') {
          return []
        } else {
          return attribute.value['self_productCategries'].map((ele) => {
            return ele.id
          })
        }
      })()
    },
    method: 'get',
    data: {}
  })
  return res
}
export function showEyesIfFromUserPlatform(actions) {
  if(isFromUserManagePlat()){
    actions = [
      ...actions,
      'isShow'
    ]
  }
  return actions
}


export function useSynchNodesRulesInProductList(node, flag) {
  node.synchNodes = {
    nodeFlags: [flag],
    exclude: ['self_width', 'self_textInput']
  }
  return node
}

export function useStandradTitleRules(titleNode) {
  titleNode.data.design['title_fontSize'] = {
    diannao: listTitleRules.diannao.fontSize,
    pingban: listTitleRules.pingban.fontSize,
    shouji: listTitleRules.shouji.fontSize
  }
  titleNode.data.design['title_lineHeight'] = {
    diannao: listTitleRules.diannao.lineHeight,
    pingban: listTitleRules.pingban.lineHeight,
    shouji: listTitleRules.shouji.lineHeight
  }
  titleNode.data.design['title_letterSpacing'] = {
    diannao: listTitleRules.diannao.letterSpacing,
    pingban: listTitleRules.pingban.letterSpacing,
    shouji: listTitleRules.shouji.letterSpacing
  }
  titleNode.data.design['title_textThemeId'] = {
    diannao: listTitleRules.themeId,
    pingban: listTitleRules.themeId,
    shouji: listTitleRules.themeId
  }
  titleNode.data.design['title_textThemeType'] = {
    diannao: 'default',
    pingban: 'default',
    shouji: 'default'
  }
  titleNode.data.design['title_fontFamily'] = {
    diannao: listTitleRules.fontFamily,
    pingban: listTitleRules.fontFamily,
    shouji: listTitleRules.fontFamily
  }
  return titleNode
}

export function useStandradParagraphRules(paragraphNode, opts = {}) {
  paragraphNode.data.design['title_fontSize'] = {
    diannao: opts.fontSize || paragraphRules.diannao.fontSize,
    pingban: opts.fontSize ||paragraphRules.pingban.fontSize,
    shouji: opts.fontSize ||paragraphRules.shouji.fontSize
  }
  paragraphNode.data.design['title_lineHeight'] = {
    diannao: paragraphRules.diannao.lineHeight,
    pingban: paragraphRules.pingban.lineHeight,
    shouji: paragraphRules.shouji.lineHeight
  }
  paragraphNode.data.design['title_letterSpacing'] = {
    diannao: paragraphRules.diannao.letterSpacing,
    pingban: paragraphRules.pingban.letterSpacing,
    shouji: paragraphRules.shouji.letterSpacing
  }
  paragraphNode.data.design['title_textThemeId'] = {
    diannao: paragraphRules.themeId,
    pingban: paragraphRules.themeId,
    shouji: paragraphRules.themeId
  }
  paragraphNode.data.design['title_textThemeType'] = {
    diannao: 'default',
    pingban: 'default',
    shouji: 'default'
  }
  paragraphNode.data.design['title_fontFamily'] = {
    diannao: paragraphRules.fontFamily,
    pingban: paragraphRules.fontFamily,
    shouji: paragraphRules.fontFamily
  }
  return paragraphNode
}

export function useStandradButtonRules(buttonNode) {
  if (buttonNode.componentName === 'button_text_icon') {
    buttonNode.data.design['self_width'] = {
      diannao: textIconButtonRules.diannao.width,
      pingban: textIconButtonRules.pingban.width,
      shouji: textIconButtonRules.shouji.width
    }
    buttonNode.data.design['self_fontSize'] = {
      diannao: textIconButtonRules.diannao.fontSize,
      pingban: textIconButtonRules.pingban.fontSize,
      shouji: textIconButtonRules.shouji.fontSize
    }
    buttonNode.data.design['self_paddingTop'] = {
      diannao: textIconButtonRules.diannao.paddingTop,
      pingban: textIconButtonRules.pingban.paddingTop,
      shouji: textIconButtonRules.shouji.paddingTop
    }
    buttonNode.data.design['self_paddingBottom'] = {
      diannao: textIconButtonRules.diannao.paddingBottom,
      pingban: textIconButtonRules.pingban.paddingBottom,
      shouji: textIconButtonRules.shouji.paddingBottom
    }
    buttonNode.data.design['self_paddingLeft'] = {
      diannao: textIconButtonRules.diannao.paddingLeft,
      pingban: textIconButtonRules.pingban.paddingLeft,
      shouji: textIconButtonRules.shouji.paddingLeft
    }
    buttonNode.data.design['self_paddingRight'] = {
      diannao: textIconButtonRules.diannao.paddingRight,
      pingban: textIconButtonRules.pingban.paddingRight,
      shouji: textIconButtonRules.shouji.paddingRight
    }

    buttonNode.data.design['self_textThemeId'] = {
      diannao: paragraphRules.themeId,
      pingban: paragraphRules.themeId,
      shouji: paragraphRules.themeId
    }
    buttonNode.data.design['self_textThemeType'] = {
      diannao: 'default',
      pingban: 'default',
      shouji: 'default'
    }

  } else if (buttonNode.componentName === 'button_text') {
    buttonNode.data.design['self_width'] = {
      diannao: textIconButtonRules.diannao.width,
      pingban: textIconButtonRules.pingban.width,
      shouji: textIconButtonRules.shouji.width
    }
    buttonNode.data.design['self_fontSize'] = {
      diannao: textIconButtonRules.diannao.fontSize,
      pingban: textIconButtonRules.pingban.fontSize,
      shouji: textIconButtonRules.shouji.fontSize
    }
    buttonNode.data.design['self_paddingTop'] = {
      diannao: textIconButtonRules.diannao.paddingTop,
      pingban: textIconButtonRules.pingban.paddingTop,
      shouji: textIconButtonRules.shouji.paddingTop
    }
    buttonNode.data.design['self_paddingBottom'] = {
      diannao: textIconButtonRules.diannao.paddingBottom,
      pingban: textIconButtonRules.pingban.paddingBottom,
      shouji: textIconButtonRules.shouji.paddingBottom
    }
    buttonNode.data.design['self_paddingLeft'] = {
      diannao: textIconButtonRules.diannao.paddingLeft,
      pingban: textIconButtonRules.pingban.paddingLeft,
      shouji: textIconButtonRules.shouji.paddingLeft
    }
    buttonNode.data.design['self_paddingRight'] = {
      diannao: textIconButtonRules.diannao.paddingRight,
      pingban: textIconButtonRules.pingban.paddingRight,
      shouji: textIconButtonRules.shouji.paddingRight
    }

    buttonNode.data.design['self_textThemeId'] = {
      diannao: paragraphRules.themeId,
      pingban: paragraphRules.themeId,
      shouji: paragraphRules.themeId
    }
    buttonNode.data.design['self_textThemeType'] = {
      diannao: 'default',
      pingban: 'default',
      shouji: 'default'
    }

  }

  return buttonNode
}


export function useStandradButtonRulesOnlyFontSize(buttonNode) {
  if (buttonNode.componentName === 'button_text_icon') {
    buttonNode.data.design['self_fontSize'] = {
      diannao: textIconButtonRules.diannao.fontSize,
      pingban: textIconButtonRules.pingban.fontSize,
      shouji: textIconButtonRules.shouji.fontSize
    }

    buttonNode.data.design['self_textThemeId'] = {
      diannao: paragraphRules.themeId,
      pingban: paragraphRules.themeId,
      shouji: paragraphRules.themeId
    }
    buttonNode.data.design['self_textThemeType'] = {
      diannao: 'default',
      pingban: 'default',
      shouji: 'default'
    }
  } else if (buttonNode.componentName === 'button_text') {
    buttonNode.data.design['self_fontSize'] = {
      diannao: textIconButtonRules.diannao.fontSize,
      pingban: textIconButtonRules.pingban.fontSize,
      shouji: textIconButtonRules.shouji.fontSize
    }

    buttonNode.data.design['self_textThemeId'] = {
      diannao: paragraphRules.themeId,
      pingban: paragraphRules.themeId,
      shouji: paragraphRules.themeId
    }
    buttonNode.data.design['self_textThemeType'] = {
      diannao: 'default',
      pingban: 'default',
      shouji: 'default'
    }
  }

  return buttonNode
}


export function useStandradButtonRulesOfLanguagePackage(node, languagePackageField, isEdit = true) {
  node.data.design.self_text = '{{' + languagePackageField + '}}'

  if(isEdit){
    var desgin = node.actions.find((action)=>{
      if(action.name === 'design'){
        return true
      }
    })
    if(!desgin.config['文字设计'].includes('self_textInput')){
      desgin.config['文字设计'].unshift('self_textInput')
    }

  }

  if(!node.actions.includes('translate')){
    node.actions.push('translate')
  }

  return node
}




export const themeColor = {
  dominantColor: 'var(--dominantColor)',
  "secondaryColor": "var(--secondaryColor)",
  titleColor: 'var(--titleColor)',
  paragraphColor: 'var(--paragraphColor)',
  btnBorderColor: 'var(--btnBorderColor)',
  whiteColor: 'var(--writeColor)',
  "presetColor1": "",
  "presetColor2": "",
  "presetColor3": "",
  "presetColor4": "",
  "presetColor5": "",
  "presetColor6": "",
  transparentColor: 'var(--transparentColor)',

}


export function useThemeRulesInCombineNode(node, opts = {}) {
  if(
    node.componentName === 'button_text' ||
    node.componentName === 'button_text_icon'
  ){
    if(opts.btnType === 'fill'){
      node.data.design.self_color = {
        diannao: themeColor.whiteColor,
        pingban: themeColor.whiteColor,
        shouji: themeColor.whiteColor
      }
      node.data.design.self_backgroundColor = {
        diannao: themeColor.dominantColor,
        pingban: themeColor.dominantColor,
        shouji: themeColor.dominantColor
      }


      node.data.hover.self_hoverColor = {
        diannao: themeColor.dominantColor,
        pingban: themeColor.dominantColor,
        shouji: themeColor.dominantColor
      }
      node.data.hover.self_hoverBackgroundColor = {
        diannao: themeColor.whiteColor,
        pingban: themeColor.whiteColor,
        shouji: themeColor.whiteColor
      }


      node.data.design.self_borderTopColor = {
        diannao: themeColor.dominantColor,
        pingban: themeColor.dominantColor,
        shouji: themeColor.dominantColor
      }
      node.data.design.self_borderTopWidth = {
        diannao: 1,
        pingban: 1,
        shouji: 1
      }


      node.data.hover.self_hoverBorderTopColor = {
        diannao: themeColor.dominantColor,
        pingban: themeColor.dominantColor,
        shouji: themeColor.dominantColor
      }
      node.data.hover.self_hoverBorderTopWidth = {
        diannao: 1,
        pingban: 1,
        shouji: 1
      }

      node.data.design.self_borderRightColor = {
        diannao: themeColor.dominantColor,
        pingban: themeColor.dominantColor,
        shouji: themeColor.dominantColor
      }
      node.data.design.self_borderRightWidth = {
        diannao: 1,
        pingban: 1,
        shouji: 1
      }

      node.data.design.self_borderBottomColor = {
        diannao: themeColor.dominantColor,
        pingban: themeColor.dominantColor,
        shouji: themeColor.dominantColor
      }
      node.data.design.self_borderBottomWidth = {
        diannao: 1,
        pingban: 1,
        shouji: 1
      }

      node.data.design.self_borderLeftColor = {
        diannao: themeColor.dominantColor,
        pingban: themeColor.dominantColor,
        shouji: themeColor.dominantColor
      }
      node.data.design.self_borderLeftWidth = {
        diannao: 1,
        pingban: 1,
        shouji: 1
      }

      node.data.hover.self_hoverBorderTopColor = {
        diannao: themeColor.dominantColor,
        pingban: themeColor.dominantColor,
        shouji: themeColor.dominantColor
      }
      node.data.hover.self_hoverBorderTopWidth = {
        diannao: 1,
        pingban: 1,
        shouji: 1
      }

      node.data.hover.self_hoverBorderRightColor = {
        diannao: themeColor.dominantColor,
        pingban: themeColor.dominantColor,
        shouji: themeColor.dominantColor
      }
      node.data.hover.self_hoverBorderRightWidth = {
        diannao: 1,
        pingban: 1,
        shouji: 1
      }

      node.data.hover.self_hoverBorderBottomColor = {
        diannao: themeColor.dominantColor,
        pingban: themeColor.dominantColor,
        shouji: themeColor.dominantColor
      }
      node.data.hover.self_hoverBorderBottomWidth = {
        diannao: 1,
        pingban: 1,
        shouji: 1
      }

      node.data.hover.self_hoverBorderLeftColor = {
        diannao: themeColor.dominantColor,
        pingban: themeColor.dominantColor,
        shouji: themeColor.dominantColor
      }
      node.data.hover.self_hoverBorderLeftWidth = {
        diannao: 1,
        pingban: 1,
        shouji: 1
      }
    }
    else if(opts.btnType === 'stroke'){




      node.data.design.self_color = {
        diannao: themeColor.dominantColor,
        pingban: themeColor.dominantColor,
        shouji: themeColor.dominantColor
      }
      node.data.hover.self_hoverColor = {
        diannao: themeColor.whiteColor,
        pingban: themeColor.whiteColor,
        shouji: themeColor.whiteColor
      }

      node.data.design.self_backgroundColor = {
        diannao: themeColor.whiteColor,
        pingban: themeColor.whiteColor,
        shouji: themeColor.whiteColor
      }
      node.data.hover.self_hoverBackgroundColor = {
        diannao: themeColor.dominantColor,
        pingban: themeColor.dominantColor,
        shouji: themeColor.dominantColor
      }



      node.data.design.self_borderTopColor = {
        diannao: themeColor.dominantColor,
        pingban: themeColor.dominantColor,
        shouji: themeColor.dominantColor
      }
      node.data.design.self_borderTopWidth = {
        diannao: 1,
        pingban: 1,
        shouji: 1
      }

      node.data.design.self_borderRightColor = {
        diannao: themeColor.dominantColor,
        pingban: themeColor.dominantColor,
        shouji: themeColor.dominantColor
      }
      node.data.design.self_borderRightWidth = {
        diannao: 1,
        pingban: 1,
        shouji: 1
      }

      node.data.design.self_borderBottomColor = {
        diannao: themeColor.dominantColor,
        pingban: themeColor.dominantColor,
        shouji: themeColor.dominantColor
      }
      node.data.design.self_borderBottomWidth = {
        diannao: 1,
        pingban: 1,
        shouji: 1
      }

      node.data.design.self_borderLeftColor = {
        diannao: themeColor.dominantColor,
        pingban: themeColor.dominantColor,
        shouji: themeColor.dominantColor
      }
      node.data.design.self_borderLeftWidth = {
        diannao: 1,
        pingban: 1,
        shouji: 1
      }

      node.data.hover.self_hoverBorderTopColor = {
        diannao: themeColor.dominantColor,
        pingban: themeColor.dominantColor,
        shouji: themeColor.dominantColor
      }
      node.data.hover.self_hoverBorderTopWidth = {
        diannao: 1,
        pingban: 1,
        shouji: 1
      }

      node.data.hover.self_hoverBorderRightColor = {
        diannao: themeColor.dominantColor,
        pingban: themeColor.dominantColor,
        shouji: themeColor.dominantColor
      }
      node.data.hover.self_hoverBorderRightWidth = {
        diannao: 1,
        pingban: 1,
        shouji: 1
      }

      node.data.hover.self_hoverBorderBottomColor = {
        diannao: themeColor.dominantColor,
        pingban: themeColor.dominantColor,
        shouji: themeColor.dominantColor
      }
      node.data.hover.self_hoverBorderBottomWidth = {
        diannao: 1,
        pingban: 1,
        shouji: 1
      }

      node.data.hover.self_hoverBorderLeftColor = {
        diannao: themeColor.dominantColor,
        pingban: themeColor.dominantColor,
        shouji: themeColor.dominantColor
      }
      node.data.hover.self_hoverBorderLeftWidth = {
        diannao: 1,
        pingban: 1,
        shouji: 1
      }
    }
    else if(opts.btnType === 'onlyText'){
      /*
      * 文字颜色/图标颜色         设计（标题色）    划过（主色）
      * */

      node.data.design.self_color = {
        diannao: opts.color || themeColor.titleColor,
        pingban: opts.color || themeColor.titleColor,
        shouji: opts.color || themeColor.titleColor
      }
      node.data.hover.self_hoverColor = {
        diannao: opts.hoverColor || themeColor.dominantColor,
        pingban: opts.hoverColor || themeColor.dominantColor,
        shouji: opts.hoverColor || themeColor.dominantColor
      }
      node.data.hover.self_hoverBackgroundColor = {
        diannao: '',
        pingban: '',
        shouji: ''
      }
      // node.data.design.self_textDecoration = {
      //   "diannao": "underline",
      //   "pingban": "underline",
      //   "shouji": "underline"
      // }
      // node.data.hover.self_hoverTextDecoration = {
      //   "diannao": "underline",
      //   "pingban": "underline",
      //   "shouji": "underline"
      // }

      node.data.design.self_borderTopWidth = {
        "diannao": 0,
        "pingban": 0,
        "shouji": 0
      }
      node.data.design.self_borderRightWidth = {
        "diannao": 0,
        "pingban": 0,
        "shouji": 0
      }
      node.data.design.self_borderBottomWidth = {
        "diannao": 0,
        "pingban": 0,
        "shouji": 0
      }
      node.data.design.self_borderLeftWidth = {
        "diannao": 0,
        "pingban": 0,
        "shouji": 0
      }

      node.data.hover.self_hoverBorderTopWidth = {
        "diannao": 0,
        "pingban": 0,
        "shouji": 0
      }
      node.data.hover.self_hoverBorderRightWidth = {
        "diannao": 0,
        "pingban": 0,
        "shouji": 0
      }
      node.data.hover.self_hoverBorderBottomWidth = {
        "diannao": 0,
        "pingban": 0,
        "shouji": 0
      }
      node.data.hover.self_hoverBorderLeftWidth = {
        "diannao": 0,
        "pingban": 0,
        "shouji": 0
      }

    }
  }
  else if(node.componentName === 'icon'){
    node.data.design.icon_color = {
      diannao: themeColor.whiteColor,
      pingban: themeColor.whiteColor,
      shouji: themeColor.whiteColor
    }
    node.data.design.self_backgroundColor = {
      diannao: themeColor.dominantColor,
      pingban: themeColor.dominantColor,
      shouji: themeColor.dominantColor
    }


    node.data.hover.icon_hoverColor = {
      diannao: themeColor.dominantColor,
      pingban: themeColor.dominantColor,
      shouji: themeColor.dominantColor
    }
    node.data.hover.self_hoverBackgroundColor = {
      diannao: themeColor.whiteColor,
      pingban: themeColor.whiteColor,
      shouji: themeColor.whiteColor
    }


    node.data.design.self_borderTopColor = {
      diannao: themeColor.dominantColor,
      pingban: themeColor.dominantColor,
      shouji: themeColor.dominantColor
    }
    node.data.design.self_borderTopWidth = {
      diannao: 1,
      pingban: 1,
      shouji: 1
    }


    node.data.hover.self_hoverBorderTopColor = {
      diannao: themeColor.dominantColor,
      pingban: themeColor.dominantColor,
      shouji: themeColor.dominantColor
    }
    node.data.hover.self_hoverBorderTopWidth = {
      diannao: 1,
      pingban: 1,
      shouji: 1
    }

    node.data.design.self_borderRightColor = {
      diannao: themeColor.dominantColor,
      pingban: themeColor.dominantColor,
      shouji: themeColor.dominantColor
    }
    node.data.design.self_borderRightWidth = {
      diannao: 1,
      pingban: 1,
      shouji: 1
    }

    node.data.design.self_borderBottomColor = {
      diannao: themeColor.dominantColor,
      pingban: themeColor.dominantColor,
      shouji: themeColor.dominantColor
    }
    node.data.design.self_borderBottomWidth = {
      diannao: 1,
      pingban: 1,
      shouji: 1
    }

    node.data.design.self_borderLeftColor = {
      diannao: themeColor.dominantColor,
      pingban: themeColor.dominantColor,
      shouji: themeColor.dominantColor
    }
    node.data.design.self_borderLeftWidth = {
      diannao: 1,
      pingban: 1,
      shouji: 1
    }

    node.data.hover.self_hoverBorderTopColor = {
      diannao: themeColor.dominantColor,
      pingban: themeColor.dominantColor,
      shouji: themeColor.dominantColor
    }
    node.data.hover.self_hoverBorderTopWidth = {
      diannao: 1,
      pingban: 1,
      shouji: 1
    }

    node.data.hover.self_hoverBorderRightColor = {
      diannao: themeColor.dominantColor,
      pingban: themeColor.dominantColor,
      shouji: themeColor.dominantColor
    }
    node.data.hover.self_hoverBorderRightWidth = {
      diannao: 1,
      pingban: 1,
      shouji: 1
    }

    node.data.hover.self_hoverBorderBottomColor = {
      diannao: themeColor.dominantColor,
      pingban: themeColor.dominantColor,
      shouji: themeColor.dominantColor
    }
    node.data.hover.self_hoverBorderBottomWidth = {
      diannao: 1,
      pingban: 1,
      shouji: 1
    }

    node.data.hover.self_hoverBorderLeftColor = {
      diannao: themeColor.dominantColor,
      pingban: themeColor.dominantColor,
      shouji: themeColor.dominantColor
    }
    node.data.hover.self_hoverBorderLeftWidth = {
      diannao: 1,
      pingban: 1,
      shouji: 1
    }
  }
  else if(node.componentName === 'button_icon'){
    node.data.design.self_color = {
      diannao: themeColor.dominantColor,
      pingban: themeColor.dominantColor,
      shouji: themeColor.dominantColor
    }

    node.data.hover.self_hoverColor = {
      diannao: themeColor.dominantColor,
      pingban: themeColor.dominantColor,
      shouji: themeColor.dominantColor
    }
  }


  else if(
    node.componentName === 'text_title'
  ){
    //文字颜色                     设计（标题色）    划过（主色）
    node.data.design.title_color = {
      diannao: themeColor.titleColor,
      pingban: themeColor.titleColor,
      shouji: themeColor.titleColor
    }
    node.data.hover.title_hoverColor = {
      diannao: opts.hoverColor || themeColor.dominantColor,
      pingban: opts.hoverColor || themeColor.dominantColor,
      shouji: opts.hoverColor || themeColor.dominantColor
    }
  }else if(
    node.componentName === 'text_paragraph'
  ){
    // 文字颜色                     设计（段落色）    划过（段落色）
    node.data.design.title_color = {
      diannao: themeColor.paragraphColor,
      pingban: themeColor.paragraphColor,
      shouji: themeColor.paragraphColor
    }
    node.data.hover.title_hoverColor = {
      diannao: opts.hoverColor || themeColor.paragraphColor,
      pingban: opts.hoverColor || themeColor.paragraphColor,
      shouji: opts.hoverColor || themeColor.paragraphColor
    }

    if(opts.desginAndHoverUseDominantColor){
      node.data.design.title_color = {
        diannao: themeColor.dominantColor,
        pingban: themeColor.dominantColor,
        shouji: themeColor.dominantColor
      }
      node.data.hover.title_hoverColor = {
        diannao: themeColor.dominantColor,
        pingban: themeColor.dominantColor,
        shouji: themeColor.dominantColor
      }
    }
  }
  else if(
    node.componentName === 'popagation'
  ){
    node.data.design.popagationtext_color = {
      diannao: themeColor.btnBorderColor,
      pingban: themeColor.btnBorderColor,
      shouji: themeColor.btnBorderColor
    }
    node.data.hover.popagationtext_hoverColor = {
      diannao: themeColor.whiteColor,
      pingban: themeColor.whiteColor,
      shouji: themeColor.whiteColor
    }

    node.data.design.popagationtext_backgroundColor = {
      diannao: themeColor.whiteColor,
      pingban: themeColor.whiteColor,
      shouji: themeColor.whiteColor
    }
    node.data.hover.popagationtext_hoverBackgroundColor = {
      diannao: themeColor.dominantColor,
      pingban: themeColor.dominantColor,
      shouji: themeColor.dominantColor
    }


    node.data.design.popagationnarrowtext_color = {
      diannao: themeColor.btnBorderColor,
      pingban: themeColor.btnBorderColor,
      shouji: themeColor.btnBorderColor
    }
    node.data.hover.popagationnarrowtext_hoverColor = {
      diannao: themeColor.dominantColor,
      pingban: themeColor.dominantColor,
      shouji: themeColor.dominantColor
    }

    node.data.design.popagationnarrowtext_backgroundColor = {
      diannao: themeColor.transparentColor,
      pingban: themeColor.transparentColor,
      shouji: themeColor.transparentColor
    }
    node.data.hover.popagationnarrowtext_hoverBackgroundColor = {
      diannao: themeColor.transparentColor,
      pingban: themeColor.transparentColor,
      shouji: themeColor.transparentColor
    }

    node.data.design.popBorder_borderTopColor = {
      diannao: themeColor.btnBorderColor,
      pingban: themeColor.btnBorderColor,
      shouji: themeColor.btnBorderColor
    }
    node.data.hover.popBorder_hoverBorderTopColor = {
      diannao: themeColor.btnBorderColor,
      pingban: themeColor.btnBorderColor,
      shouji: themeColor.btnBorderColor
    }

    node.data.design.popBorder_borderRightColor = {
      diannao: themeColor.btnBorderColor,
      pingban: themeColor.btnBorderColor,
      shouji: themeColor.btnBorderColor
    }
    node.data.hover.popBorder_hoverBorderRightColor = {
      diannao: themeColor.btnBorderColor,
      pingban: themeColor.btnBorderColor,
      shouji: themeColor.btnBorderColor
    }

    node.data.design.popBorder_borderBottomColor = {
      diannao: themeColor.btnBorderColor,
      pingban: themeColor.btnBorderColor,
      shouji: themeColor.btnBorderColor
    }
    node.data.hover.popBorder_hoverBorderBottomColor = {
      diannao: themeColor.btnBorderColor,
      pingban: themeColor.btnBorderColor,
      shouji: themeColor.btnBorderColor
    }

    node.data.design.popBorder_borderLeftColor = {
      diannao: themeColor.btnBorderColor,
      pingban: themeColor.btnBorderColor,
      shouji: themeColor.btnBorderColor
    }
    node.data.hover.popBorder_hoverBorderLeftColor = {
      diannao: themeColor.btnBorderColor,
      pingban: themeColor.btnBorderColor,
      shouji: themeColor.btnBorderColor
    }


    node.data.design.narrowBorder_borderTopColor = {
      diannao: themeColor.transparentColor,
      pingban: themeColor.transparentColor,
      shouji: themeColor.transparentColor
    }
    node.data.hover.narrowBorder_hoverBorderTopColor = {
      diannao: themeColor.transparentColor,
      pingban: themeColor.transparentColor,
      shouji: themeColor.transparentColor
    }

    node.data.design.narrowBorder_borderRightColor = {
      diannao: themeColor.transparentColor,
      pingban: themeColor.transparentColor,
      shouji: themeColor.transparentColor
    }
    node.data.hover.narrowBorder_hoverBorderRightColor = {
      diannao: themeColor.transparentColor,
      pingban: themeColor.transparentColor,
      shouji: themeColor.transparentColor
    }

    node.data.design.narrowBorder_borderBottomColor = {
      diannao: themeColor.transparentColor,
      pingban: themeColor.transparentColor,
      shouji: themeColor.transparentColor
    }
    node.data.hover.narrowBorder_hoverBorderBottomColor = {
      diannao: themeColor.transparentColor,
      pingban: themeColor.transparentColor,
      shouji: themeColor.transparentColor
    }

    node.data.design.narrowBorder_borderLeftColor = {
      diannao: themeColor.transparentColor,
      pingban: themeColor.transparentColor,
      shouji: themeColor.transparentColor
    }
    node.data.hover.narrowBorder_hoverBorderLeftColor = {
      diannao: themeColor.transparentColor,
      pingban: themeColor.transparentColor,
      shouji: themeColor.transparentColor
    }



  }






  return node
}

export function useArabicRulesInCombineNode(node){
  node = supportRtlInNode(node)
  return node
}

export function useGlobalPopagation(node){
  node.data.design = undefined
  node.data.hover = undefined

  return node
}


